import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const maintenanceWorkflowSchedulesKindOptions = [
  { label: 'Preventiva', value: 'preventive' },
  { label: 'Urgência', value: 'urgency' },
  { label: 'Compras de peças', value: 'parts_purchases' },
  { label: 'Garantia', value: 'guarantee' },
]

export const maintenanceWorkflowSchedulesKindStrategy = optionsToStrategy(maintenanceWorkflowSchedulesKindOptions)
